import { FilterSelector } from '@delmonicos/shared-design-system-react/src/components/filter-selector/filter-selector';
import { useTranslation } from 'react-i18next';

import { useEmspBoGetCposQuery } from '@app/core/service/emsp-bo-cpo.service';

interface EmspBoLocationCpoFilterControllerProps {
  value: string | undefined;
  onChange: (value: string) => void;
}

export const EmspBoLocationCpoFilterController = ({
  value,
  onChange,
}: EmspBoLocationCpoFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const { data, isLoading } = useEmspBoGetCposQuery({ limit: 100, offset: 0 });

  const items = (data?.docs ?? []).map((cpo) => ({
    key: cpo.id,
    value: `${cpo.id} - ${cpo.endpoint}`,
  }));

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilterSelector
      items={items}
      initialSelectedItemIds={value ? [value] : []}
      onChange={(ids) => onChange(ids.at(-1) ?? '')}
      isLoading={isLoading}
      hasSeeMore={false}
      onSearchChange={() => {}}
      onOffsetChange={() => {}}
      labels={{
        title: t('$.emsp-bo-location-list-filter.cpo-label'),
        search: t('$.emsp-bo-location-list-filter.cpo-search'),
        seeMore: '',
      }}
      icon="wifi"
    />
  );
};
